import { render, staticRenderFns } from "./AutoTest.vue?vue&type=template&id=345e76ea&scoped=true&"
import script from "./AutoTest.vue?vue&type=script&lang=js&"
export * from "./AutoTest.vue?vue&type=script&lang=js&"
import style0 from "./AutoTest.vue?vue&type=style&index=0&id=345e76ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e76ea",
  null
  
)

export default component.exports